module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"timeAgo":"{timeAgo} ago"}}')
  delete Component.options._Ctor
}
